// Get Queries By Source Use Case
import { QueriesRepository } from "../repositories/QueriesRepository";
import {
  QueryEntity,
  QueryFilters,
  QueryListResult,
} from "../entities/QueryEntity";
import { Result } from "../common/Result";

export class GetQueriesBySourceUseCase {
  constructor(private repository: QueriesRepository) {}

  async execute(
    source: string,
    sourceId?: number,
    filters?: QueryFilters,
    limit: number = 20,
    offset: number = 0
  ): Promise<Result<QueryListResult>> {
    try {
      if (!source) {
        return Result.fail("Source type is required");
      }

      const queries = await this.repository.getQueriesBySource(
        source,
        sourceId,
        filters,
        limit,
        offset
      );
      return Result.ok(queries);
    } catch (error: any) {
      return Result.fail(error.message || "Failed to fetch queries by source");
    }
  }
}

